import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { ButtonComponent } from '../button/button.component';
import { DialogButton, DialogConfig } from '../../../../core/services/utils/dialog.service';

@Component({
  selector: 'app-dialog-card',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    ButtonComponent,
  ],
  templateUrl: './dialog-card.component.html',
  styleUrls: ['./dialog-card.component.scss'],
})
export class DialogCardComponent {
  data = inject<DialogConfig & { buttons: DialogButton[] }>(MAT_DIALOG_DATA);

  get image(): string | null {
    if (!this.data.image) return null;
    return 'images/' + this.data.image + (this.data.image.includes('loading') ? '.gif' : '.png');
  }

  isArray(value: unknown): value is string[] {
    return Array.isArray(value);
  }
}
